/**
 * GridLab-inspired EMS SEO phrases for 220-km Open EMS / B2B energy stack.
 * Adapted from https://gridlab.com.ua/uk — microgrid, BESS, RDN/VDN arbitrage, ML forecasting.
 */

export const EMS_SEO_KEYWORDS_UK = [
  'система розумного керування енергією',
  'система керування енергією EMS',
  'мікромережа',
  'мікрогрід EMS',
  'BESS моніторинг',
  'моніторинг СЕС',
  'моніторинг сонячної станції',
  'ML-прогноз сонячної генерації',
  'ML-прогноз цін РДН',
  'арбітраж електроенергії',
  'арбітраж РДН ВДР',
  'РДН ринок доба наперед',
  'ВДР внутрішньодобовий ринок',
  'активний споживач',
  'острівний режим',
  'автоматизоване сценарне керування',
  'заряд розряд BESS',
  'економія на споживанні енергії',
  'заробіток на трейдингу електроенергії',
  'Modbus MQTT OPC UA',
  'Huawei FusionSolar',
  'Deye inverter',
  'Huawei BESS',
  'KSTAR BESS',
  'енергоменеджмент Україна',
  'балансування ОЕС',
  'керування генерацією',
  'керування споживанням',
  'прогноз факт СЕС',
  'ROI аналітика енергії',
  'Open EMS',
  'open-ems',
  '220-km EMS',
].join(', ');

export const EMS_SEO_KEYWORDS_EN = [
  'smart energy management system',
  'energy management system EMS',
  'microgrid EMS',
  'BESS monitoring',
  'solar plant monitoring',
  'ML solar generation forecast',
  'ML day-ahead price forecast',
  'electricity arbitrage',
  'DAM IDM arbitrage Ukraine',
  'active consumer',
  'island mode microgrid',
  'automated charge discharge scenarios',
  'energy cost savings',
  'electricity trading',
  'Modbus MQTT OPC UA',
  'Huawei FusionSolar',
  'Deye inverter',
  'grid balancing',
  'generation management',
  'load management',
  'Open EMS',
  'open-ems',
  '220-km EMS',
].join(', ');

export const EMS_SEO_DESCRIPTION_UK =
  'Open EMS від 220-km — система розумного керування енергією для мікромереж: СЕС, BESS та зарядка EV. Автоматизоване сценарне керування заряд/розряд, арбітраж на РДН та ВДР (OREE), ML-прогноз генерації та цін, Modbus/MQTT/OPC UA, острівний режим і балансування ОЕС.';

export const EMS_SEO_DESCRIPTION_EN =
  'Open EMS by 220-km — smart energy management for microgrids: solar, BESS, and EV charging. Automated charge/discharge scenarios, DAM/IDM arbitrage (OREE), ML generation and price forecasts, Modbus/MQTT/OPC UA, island mode, and grid balancing.';

export const EMS_OPEN_EMS_STRUCTURED_DESCRIPTION =
  'Open-source smart energy management system: microgrid automation for solar, BESS, and EV charging. Automated charge/discharge scenarios, OREE DAM/IDM arbitrage, ML solar and price forecasts, Modbus/MQTT/OPC UA, island mode, real-time power flow, ROI analytics — self-hosted FastAPI + React.';
